<!-- Main Container with constrained width -->
<div class="w-full max-w-full">
  <!-- Compact Controls Section -->
  <div class="mb-3 w-full">
    <div class="flex items-center justify-between gap-2 flex-wrap">
      <!-- View mode buttons + owner filter -->
      <div class="flex items-center gap-1.5">
        <div
          class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
        >
          <button
            type="button"
            (click)="setOwnerFilter()"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="
              filtroOwner === undefined
                ? 'bg-brand-500 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            "
          >
            Todos
          </button>
          <button
            type="button"
            (click)="setOwnerFilter()"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="
              filtroOwner === currentUser
                ? 'bg-brand-500 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            "
          >
            Mis negocios
          </button>
          <button
            type="button"
            (click)="setArchivesDeals()"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="
              filters.archived
                ? 'bg-brand-500 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            "
          >
            Archivados
          </button>
        </div>
        <button
          type="button"
          (click)="changeViewMode('dealCycle')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="
            viewMode === 'dealCycle'
              ? 'bg-brand-500 text-white'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          "
        >
          Ciclo
        </button>
      </div>

      <!-- Action buttons -->
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="toggleFilters()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            ></path>
          </svg>
          {{ showFilters ? 'Ocultar' : 'Filtros' }}
        </button>
        <button
          type="button"
          (click)="vistaLista()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 10h16M4 14h16M4 18h16"
            ></path>
          </svg>
          Lista
        </button>
        <button
          type="button"
          *appHasPermission="'deals:create'"
          (click)="nuevoDeal()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4v16m8-8H4"
            ></path>
          </svg>
          Nuevo Negocio
        </button>
      </div>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
    <div
      class="mb-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 w-full"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Búsqueda por nombre -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por nombre
          </label>
          <input
            type="text"
            [(ngModel)]="filters.searchName"
            (ngModelChange)="buscarTexto()"
            placeholder="Nombre del negocio..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Etapa (solo si no es el modo actual) -->
        @if (availableFilterFields.dealCycle) {
          <div>
            <label
              class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Etapa
            </label>
            <select
              [(ngModel)]="filters.idDealCycle"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              <option [ngValue]="undefined">Todos</option>
              @for (cycle of dealCycles; track cycle.id) {
                <option [ngValue]="cycle.id">{{ cycle.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Tipo de Negocio -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Tipo de Negocio
          </label>
          <select
            [(ngModel)]="filters.idDealBusinessType"
            (ngModelChange)="applyFilters()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos los tipos</option>
            @for (bt of dealBusinessTypes; track bt.id) {
              <option [ngValue]="bt.id">{{ bt.name }}</option>
            }
          </select>
        </div>

        <!-- Filtro Prioridad -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Prioridad
          </label>
          <select
            [(ngModel)]="filters.idDealPriority"
            (ngModelChange)="applyFilters()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todas las prioridades</option>
            @for (p of dealPriorities; track p.id) {
              <option [ngValue]="p.id">{{ p.name }}</option>
            }
          </select>
        </div>

        <!-- Filtro Monto Mínimo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Valor Mínimo
          </label>
          <input
            type="number"
            [(ngModel)]="filters.minAmount"
            (ngModelChange)="applyFilters()"
            placeholder="0"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Monto Máximo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Valor Máximo
          </label>
          <input
            type="number"
            [(ngModel)]="filters.maxAmount"
            (ngModelChange)="applyFilters()"
            placeholder="999999"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Estado -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Estado
          </label>
          <select
            [(ngModel)]="filters.activeOnly"
            (ngModelChange)="applyFilters()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="true">Activos</option>
            <option [ngValue]="false">Cerrados</option>
          </select>
        </div>

        <!-- Filtro Por Responsable (Inc 23) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Responsable
          </label>
          <app-entity-select
            [value]="filtroOwner ?? null"
            [displayText]="ownerFilterDisplay"
            [searchFn]="userSearch"
            [labelFn]="userLabel"
            [sublabelFn]="userSublabel"
            (valueChange)="onOwnerFilterChange($event)"
            placeholder="Buscar responsable por nombre o correo…"
          ></app-entity-select>
        </div>

        <!-- Filtro Por Empresa (Inc 23) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Empresa
          </label>
          <app-entity-select
            [value]="filtroCompanyId ?? null"
            [displayText]="filtroCompanyName"
            [searchFn]="companyFilterSearch"
            [labelFn]="companyFilterLabel"
            (valueChange)="onCompanyFilterChange($event)"
            (selected)="filtroCompanyName = $event ? $event.commercialName : ''"
            placeholder="Buscar empresa por nombre…"
          ></app-entity-select>
        </div>

        <!-- Filtro Fecha de cierre estimada (Inc 23) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Cierre estimado desde
          </label>
          <input
            type="date"
            [(ngModel)]="filtroEstimatedCloseFrom"
            (ngModelChange)="applyFilters()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Cierre estimado hasta
          </label>
          <input
            type="date"
            [(ngModel)]="filtroEstimatedCloseTo"
            (ngModelChange)="applyFilters()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro País (por prefijo telefónico del contacto principal) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            País
          </label>
          <app-country-select
            [countries]="filterCountries"
            [value]="filtroPais"
            [clearable]="true"
            placeholder="Todos"
            (valueChange)="onCountryFilterChange($event)" />
        </div>

        <!-- Botón Limpiar Filtros -->
        <div class="flex items-end">
          <button
            type="button"
            (click)="clearFilters()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading State -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"
      ></div>
    </div>
  }

  <!-- Error State -->
  @if (error) {
    <div
      class="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-error-700 dark:text-error-400 px-4 py-3 rounded mb-6"
    >
      {{ error }}
    </div>
  }

  <!-- Kanban Board with Horizontal Scroll -->
  @if (!loading && !error) {
    <div class="kanban-container overflow-x-auto w-full">
      <div
        class="flex gap-4 pb-4"
        style="min-width: fit-content"
      >
        @for (column of columns; track column.id; let colIndex = $index) {
          <div
            class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 min-w-72 w-72 shrink-0"
          >
            <!-- Header de la columna -->
            <div class="flex items-center justify-between mb-4">
              <div class="flex items-center gap-2">
                <div class="w-3 h-3 rounded-full {{ column.color }}"></div>
                <h3 class="font-semibold text-gray-900 dark:text-white">
                  {{ column.name }}
                </h3>
              </div>
              <span
                class="text-xs font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-1 rounded"
              >
                {{ column.deals.length }} negocios
              </span>
            </div>

            <!-- Lista de negocios con drag & drop -->
            <div
              cdkDropList
              [id]="'col-' + column.id"
              [cdkDropListData]="column.deals"
              [cdkDropListConnectedTo]="getColumnIds()"
              (cdkDropListDropped)="drop($event, column)"
              class="min-h-125 max-h-175 overflow-y-auto space-y-3"
            >
              @for (deal of column.deals; track deal.id) {
                <!-- Arrastrar la tarjeta CAMBIA la etapa del negocio: es editar, y sin ese
                     permiso el backend responde 403 tras haber movido la tarjeta. -->
                <div
                  cdkDrag
                  [cdkDragDisabled]="!puedeEditar"
                  (click)="verDetalle(deal)"
                  class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-md transition-shadow relative group cursor-pointer overflow-hidden"
                >
                  <!-- Barra de prioridad (izquierda) -->
                  @if (deal.priorityColor) {
                    <div
                      class="absolute top-0 left-0 w-1 h-full"
                      [style.background-color]="deal.priorityColor"
                    ></div>
                  }

                  <!-- Contenido con padding ajustado -->
                  <div
                    class="p-3"
                    [class.pl-4]="deal.priorityColor"
                  >
                    <!-- Fila superior: Badge prioridad + botones acción -->
                    <div class="flex items-start justify-between mb-2">
                      @if (deal.priorityName && deal.priorityColor) {
                        <span
                          class="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full font-medium"
                          [style.background-color]="deal._priorityBg"
                          [style.color]="deal.priorityColor"
                        >
                          <span
                            class="w-1.5 h-1.5 rounded-full inline-block"
                            [style.background-color]="deal.priorityColor"
                          ></span>
                          {{ deal.priorityName }}
                        </span>
                      } @else {
                        <div></div>
                      }

                      <!-- Botones de acción (hover) -->
                      <div
                        class="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10"
                      >
                        <button
                          type="button"
                          *appHasPermission="'deals:edit'"
                          (click)="
                            editarDeal(deal, $event); $event.stopPropagation()
                          "
                          (mousedown)="$event.stopPropagation()"
                          class="p-1 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
                          title="Editar"
                        >
                          <svg
                            class="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            ></path>
                          </svg>
                        </button>
                        <button
                          type="button"
                          *appHasPermission="'quotes:create'"
                          (click)="
                            nuevaCotizacion(deal, $event);
                            $event.stopPropagation()
                          "
                          (mousedown)="$event.stopPropagation()"
                          class="p-1 bg-green-500 hover:bg-green-600 text-white rounded transition-colors cursor-pointer"
                          title="Nueva cotización"
                        >
                          <svg
                            class="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            ></path>
                          </svg>
                        </button>
                        <button
                          [appDisableWithoutPermission]="'deals:create'"
                          (click)="
                            nuevaCopia(deal, $event); $event.stopPropagation()
                          "
                          class="p-1 bg-purple-500 hover:bg-purple-600 text-white rounded transition-colors cursor-pointer"
                          title="Nueva copia"
                        >
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                            ></path>
                          </svg>
                        </button>
                        <button
                          type="button"
                          *appHasPermission="'deals:delete'"
                          (click)="
                            eliminarDeal(deal, column, $event);
                            $event.stopPropagation()
                          "
                          (mousedown)="$event.stopPropagation()"
                          class="p-1 bg-error-500 hover:bg-error-600 text-white rounded transition-colors cursor-pointer"
                          title="Eliminar"
                        >
                          <svg
                            class="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            ></path>
                          </svg>
                        </button>
                        @if (deal.archived) {
                          <button
                            type="button"
                            *appHasPermission="'deals:edit'"
                            (click)="
                              unarchiveDeal(deal, $event);
                              $event.stopPropagation()
                            "
                            (mousedown)="$event.stopPropagation()"
                            class="p-1 bg-orange-500 hover:bg-orange-600 text-white rounded transition-colors cursor-pointer"
                            title="Desarchivar"
                          >
                            <svg
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              class="w-4 h-4"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-5 5l-3-3m0 0l-3 3m3-3v6"
                              ></path>
                            </svg>
                          </button>
                        } @else {
                          <button
                            type="button"
                            *appHasPermission="'deals:edit'"
                            (click)="
                              archiveDeal(deal, $event);
                              $event.stopPropagation()
                            "
                            (mousedown)="$event.stopPropagation()"
                            class="p-1 bg-orange-500 hover:bg-orange-600 text-white rounded transition-colors cursor-pointer"
                            title="Archivar"
                          >
                            <svg
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              class="w-4 h-4"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                              ></path>
                            </svg>
                          </button>
                        }
                      </div>
                    </div>

                    <!-- Nombre de la compañia -->
                    <p
                      class="text-sm text-gray-900 dark:text-white leading-snug mb-2"
                    >
                      {{ resolverCompanies(deal.idCompany) }}
                    </p>
                    <!-- Nombre del negocio -->
                    <h4
                      class="font-semibold text-gray-900 dark:text-white text-sm leading-snug mb-2 flex items-center gap-2"
                    >
                      @if (countryFlagCode(deal.primaryContactPhone); as cc) {
                        <span class="fi fi-{{ cc }} rounded-sm shrink-0" [title]="countryName(deal.primaryContactPhone)"></span>
                      }
                      <span>{{ deal.name }}</span>
                    </h4>

                    <!-- Monto -->
                    @if (deal._amountDisplay) {
                      <div
                        class="inline-flex items-center gap-1 bg-brand-50 dark:bg-brand-900/20 text-brand-700 dark:text-brand-400 text-sm font-bold px-2 py-0.5 rounded mb-2"
                      >
                        <svg
                          class="w-3 h-3"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          ></path>
                        </svg>
                        {{ deal._amountDisplay }}
                      </div>
                    }

                    <!-- Empresa, Contacto, Prioridad, Fecha estimada -->
                    <div
                      class="space-y-1.5 text-xs text-gray-600 dark:text-gray-400"
                    >
                      @if (deal.companyName) {
                        <div class="flex items-center gap-1.5">
                          <svg
                            class="w-3.5 h-3.5 shrink-0 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            ></path>
                          </svg>
                          <span
                            class="truncate font-medium text-gray-700 dark:text-gray-300"
                            >{{ deal.companyName }}</span
                          >
                        </div>
                      }

                      @if (deal.contacts && deal.contacts.length > 0) {
                        <div class="flex items-start gap-1.5">
                          <svg
                            class="w-3.5 h-3.5 shrink-0 text-gray-400 mt-0.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            ></path>
                          </svg>
                          <div class="flex flex-col gap-0.5 min-w-0">
                            @for (contact of deal.contacts; track contact.id) {
                              <div class="flex items-center gap-1 min-w-0">
                                <span
                                  class="truncate"
                                  [class.font-medium]="contact.isPrimary"
                                  [class.text-gray-700]="contact.isPrimary"
                                  [class.dark:text-gray-300]="contact.isPrimary"
                                >
                                  {{ contact.contactFullname
                                  }}{{
                                    contact.contactLastname
                                      ? ' ' + contact.contactLastname
                                      : ''
                                  }}
                                </span>
                                @if (contact.isPrimary) {
                                  <span
                                    class="shrink-0 text-[10px] px-1 py-0 rounded bg-brand-100 text-brand-600 dark:bg-brand-900/30 dark:text-brand-400 leading-4"
                                    >★</span
                                  >
                                }
                                @if (contact.roleName) {
                                  <span
                                    class="shrink-0 text-[10px] text-gray-400 dark:text-gray-500 truncate"
                                    >· {{ contact.roleName }}</span
                                  >
                                }
                              </div>
                            }
                          </div>
                        </div>
                      } @else if (deal.primaryContactName) {
                        <div class="flex items-center gap-1.5">
                          <svg
                            class="w-3.5 h-3.5 shrink-0 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            ></path>
                          </svg>
                          <span class="truncate">{{
                            deal.primaryContactName
                          }}</span>
                        </div>
                      }

                      @if (deal._estimatedCloseFormatted) {
                        <div
                          class="flex items-center gap-1.5"
                          [ngClass]="
                            deal._isOverdue
                              ? 'text-red-500 dark:text-red-400'
                              : ''
                          "
                        >
                          <svg
                            class="w-3.5 h-3.5 shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            ></path>
                          </svg>
                          <span>{{ deal._estimatedCloseFormatted }}</span>
                          @if (deal._isOverdue) {
                            <span class="text-red-500 font-medium"
                              >· Vencido</span
                            >
                          }
                        </div>
                      }
                    </div>

                    <!-- Footer: Inactividad + badges -->
                    <div
                      class="flex items-center justify-between mt-2.5 pt-2 border-t border-gray-100 dark:border-gray-800"
                    >
                      @if (deal._isInactive) {
                        <div
                          class="flex items-center gap-1 text-amber-500 dark:text-amber-400 text-xs font-medium"
                        >
                          <svg
                            class="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            ></path>
                          </svg>
                          <span>{{ deal._daysSinceUpdate }}d inactivo</span>
                        </div>
                      } @else {
                        <div></div>
                      }

                      <div class="flex flex-wrap gap-1">
                        @if (viewMode !== 'dealCycle' && deal.idDealCycle) {
                          <span
                            class="text-xs px-1.5 py-0.5 rounded bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400"
                          >
                            {{ deal._cycleName }}
                          </span>
                        }
                        @if (viewMode !== 'origin' && deal.idDealOrigin) {
                          <span
                            class="text-xs px-1.5 py-0.5 rounded bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400"
                          >
                            {{ deal._originName }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }

              <!-- Estado vacío -->
              @if (column.deals.length === 0) {
                <div
                  class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600"
                >
                  <svg
                    class="w-12 h-12 mb-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    ></path>
                  </svg>
                  <p class="text-sm">No hay negocios</p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (globalTotalPages >= 1) {
      <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
        <div class="flex items-center justify-between gap-4 flex-wrap">
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-500 dark:text-gray-400">
              {{ globalTotalElements }} registros
            </span>
            <select
              [ngModel]="pageSize"
              (ngModelChange)="changePageSize($event)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                <option [value]="opt">{{ opt }}</option>
              }
            </select>
          </div>
          <div class="flex items-center gap-2">
            <button
              type="button"
              (click)="cambiarPagina(globalPage - 1)"
              [disabled]="!hasPrevPage"
              class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Anterior
            </button>
            <div class="flex items-center gap-1.5">
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >Página</span
              >
              <select
                [ngModel]="pageDisplay"
                (ngModelChange)="cambiarPagina($event - 1)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                @for (p of pagesArray; track p) {
                  <option [value]="p">{{ p }}</option>
                }
              </select>
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >de {{ globalTotalPages }}</span
              >
            </div>
            <button
              type="button"
              (click)="cambiarPagina(globalPage + 1)"
              [disabled]="!hasNextPage"
              class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    }
  }
</div>

<!-- Modal de detalle -->
<app-deal-detail-modal
  [isOpen]="showDetailModal"
  [deal]="selectedDeal"
  [dealCycles]="dealCycles"
  [dealBusinessTypes]="dealBusinessTypes"
  [dealPriorities]="dealPriorities"
  (close)="cerrarModal()"
  (dealUpdated)="onDealUpdated()"
>
</app-deal-detail-modal>
